import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import typography from './typography';
import ComponentsOverride from './overrides';
import { createCustomShadows, createThemeShadows } from './shadows';
import { useThemeMode } from './ThemeModeProvider';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const { mode } = useThemeMode();
  const themeOptions = useMemo(
    () => {
      const paletteOptions = palette(mode);
      return {
        palette: paletteOptions,
        shape,
        typography,
        shadows: createThemeShadows(paletteOptions),
        customShadows: createCustomShadows(paletteOptions)
      };
    },
    [mode]
  );

  const theme = createTheme(themeOptions);
  theme.components = ComponentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
